import { SVGProps } from 'react';
const SvgMoreGridSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14 15a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM8 15a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM14 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM8 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
    />
  </svg>
);
export default SvgMoreGridSmall;
